<template>
  <div class="container">
    <div class="jumbotron mt-5">
      <div class="col-sm-8 mx-auto">
        <h1 class="text-center">Saját fiók</h1>
      </div>
      <table class="table col-md-6 mx-auto">
        <tbody>
          <tr>
            <td>Kersztnév</td>
            <td>{{list.first_name}}</td>
          </tr>
          <tr>
            <td>Vezetéknév</td>
            <td>{{list.last_name}}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{{list.email}}</td>
          </tr>
          <tr>
            <td>Monogram</td>
            <td>{{list.monogram}}</td>
          </tr>
        </tbody>
      </table>
        <div style="text-align: center">
          <b-button
            size="sm"
            variant="primary"
            @click="$router.push({
                      name: 'UserNew',
                      params: { email: email}
                    })"
            ><b-icon-pencil></b-icon-pencil>
            Szerkesztés
          </b-button>

          <b-button
            size="sm"
            variant="warning"
            @click="$router.push({
                      name: 'UserNewPassword',
                      params: { email: email}
                    })"
            ><b-icon-pencil></b-icon-pencil>
            Jelszó váltás
          </b-button>
        </div>

    </div>
  </div>
</template>

<script>

import axios from 'axios'
import jwtDecode from 'jwt-decode'
import router from '../router'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      userType : decoded.usertype,
      first_name: decoded.first_name,
      last_name: decoded.last_name,
      monogram: decoded.monogram,
      email: decoded.email,
      list: []
    }
  },
  mounted: function () {
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.token = this.token
      payload.email = this.email
      payload.userType = this.userType
      axios
        .post('http://'+process.env.ROOT_API+'/users/profile', { payload })
        .then(res => {
          this.list = res.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}  
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue